export default "__VITE_ASSET__RZ9XkqOK__"